export default {
   path: '/multicotizador/polizas',
   name: 'poliza',
   children: [
      {
         path: '',
         name: 'poliza/consulta',
         component: () =>
            import(
               /* webpackChunkName: "poliza/consulta" */ '@/modules/poliza/views/PolizaConsultaView.vue'
            ),
      },
      {
         path: '',
         name: 'poliza/solicitudes',
         component: () =>
            import(
               /* webpackChunkName: "poliza/solicitudes" */ '@/modules/poliza/views/SolicitudConsultaView.vue'
            ),
      },
   ],
};
